var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut","appear":"","duration":300}},[(!_vm.canInteract || _vm.isBooting)?_c('div',{staticClass:"row justify-center items-center fixed-full z-max"},[_c('q-spinner-dots',{attrs:{"color":"primary","size":"2em"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }